import React, { useState } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import {
  Modal,
  Button,
  ModalBody,
  FormGroup,
  Row,
  Col,
  Input,
  Label,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/free-solid-svg-icons';

import { saveDOB } from 'Redux/ducks/auth';
import AgeOptions from 'Components/Product/Age/AgeOptions';
import MessageBox from 'Components/Utility/MessageBox';

import 'Components/Account/LoginAndSecurity/Age.scss';

const messages = defineMessages({
  day: {
    id: 'account-password.day',
    defaultMessage: 'Day',
  },
  month: {
    id: 'account-password.month',
    defaultMessage: 'Month',
  },
  year: {
    id: 'account-password.year',
    defaultMessage: 'Year',
  },
  enter_day: {
    id: 'account-password.enterday',
    defaultMessage: 'Please enter a day',
  },
  enter_month: {
    id: 'account-password.entermonth',
    defaultMessage: 'Please enter a month',
  },
  enter_year: {
    id: 'account-password.enteryear',
    defaultMessage: 'Please enter a year',
  },
  enter_valid_dob: {
    id: 'account-password.entervaliddob',
    defaultMessage: 'Please enter a valid date',
  },
  success_general_dob: {
    id: 'account-password.successgeneraldob',
    defaultMessage: 'Success',
  },
  success_dob: {
    id: 'account-password.successdob',
    defaultMessage: 'Your date of birth has been saved',
  },
  error_dob: {
    id: 'account-password.errordob',
    defaultMessage: 'Error saving your date of birth - please try again later',
  },
  errorchangingdob: {
    id: 'account-password.errorchangingdob',
    defaultMessage: 'Error Updaing Date Of Birth',
  },
});

const Age = ({ dob, intl }) => {
  const [changing, setChanging] = useState(false);
  const [currentDay, setCurrentDay] = useState('');
  const [currentMonth, setCurrentMonth] = useState('');
  const [currentYear, setCurrentYear] = useState('');
  const [ageSuccess, setAgeSuccess] = useState(false);
  const [ageFail, setAgeFail] = useState(false);
  const [ageError, setAgeError] = useState('');


  const { formatMessage, formatDate } = intl;

  const onChange = (event) => {
    event.persist();

    const { name, value } = event.target;

    if (name === 'currentDay') setCurrentDay(value);
    else if (name === 'currentMonth') setCurrentMonth(value);
    else if (name === 'currentYear') setCurrentYear(value);
  };

  const save = async () => {
    if (currentDay === '') {
      setAgeFail(true);
      setAgeError(formatMessage(messages.enter_day));
      return;
    }
    if (currentMonth === '') {
      setAgeFail(true);
      setAgeError(formatMessage(messages.enter_month));
      return;
    }
    if (currentYear === '') {
      setAgeFail(true);
      setAgeError(formatMessage(messages.enter_year));
      return;
    }

    const validDateCheck = {
      1: { min: 1, max: 31 },
      2: { min: 1, max: 29 },
      3: { min: 1, max: 31 },
      4: { min: 1, max: 30 },
      5: { min: 1, max: 31 },
      6: { min: 1, max: 30 },
      7: { min: 1, max: 31 },
      8: { min: 1, max: 31 },
      9: { min: 1, max: 30 },
      10: { min: 1, max: 31 },
      11: { min: 1, max: 30 },
      12: { min: 1, max: 31 },
    };

    const day = Number(currentDay);
    const month = Number(currentMonth);
    const year = Number(currentYear);
    const maxMin = validDateCheck[month];

    if (day < maxMin.min || day > maxMin.max) {
      setAgeFail(true);
      setAgeError(formatMessage(messages.enter_valid_dob));
      return;
    }

    const saveDob = new Date(year, month - 1, day, 0, 0, 0, 0);
    const response = await saveDOB(saveDob);
    if (!response.ok) {
      setAgeFail(true);
      setAgeError(formatMessage(messages.error_dob));
    } else {
      setAgeFail(false);
      setAgeSuccess(true);
      setAgeError(formatMessage(messages.success_dob));
    }
  };

  const toggleEdit = () => {
    let dobDay = '';
    let dobMonth = '';
    let dobYear = '';

    if (dob && dob !== '') {
      const dobDate = new Date(dob);
      const year = dobDate.getFullYear();
      let month = dobDate.getMonth() + 1;

      if (month < 10) {
        month = `0${month}`;
      }

      const day = dobDate.getDate();
      dobDay = day;
      dobMonth = month;
      dobYear = year;
    }

    setAgeSuccess(false);
    setAgeFail(false);
    setCurrentDay(dobDay);
    setCurrentMonth(dobMonth);
    setCurrentYear(dobYear);

    setChanging(!changing);
    setAgeFail(false);
  };

  const years = AgeOptions.getYears(formatMessage(messages.year));
  const months = AgeOptions.getMonths(formatMessage(messages.month));
  const days = AgeOptions.getDays(formatMessage(messages.day));


  let dobDate;
  if (dob && dob !== '') {
    dobDate = formatDate(new Date(dob), { year: 'numeric', month: 'short', day: '2-digit' });
  }

  return (
    <React.Fragment>
      <div className="account-table">
        <div className="account-table-row">
          <div className="account-table-row-title">
            <FormattedMessage id="account.setting.dob" defaultMessage="Your Date Of Birth" />
          </div>
          <div className="account-table-row-content">
            {dob && dob !== '' &&
              <div className="account-table-details-container">
                {dobDate}
              </div>
            }
            {(!dob || dob === '') &&
              <div className="account-table-details-container">
                <FormattedMessage id="account.setting.button.dob.notset" defaultMessage="Not Set" />
              </div>
            }
            <div className="account-table-action-container">
              <button type="button" className="account-table-action-button" onClick={() => toggleEdit()}>
                <FormattedMessage id="account.setting.button.dob.update" defaultMessage="Update" />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={changing} toggle={() => toggleEdit()} className="account-modal">
        <ModalBody>
          <div className="account-modal-title">
            <FormattedMessage id="account-dob.modal.title" defaultMessage="Update Your Date Of Birth" />
          </div>
          {changing &&
            <div className="account-modal-form">
              <div className="form-group">
                <FormGroup>
                  <Row>
                    <Col>
                      <Label hidden>{formatMessage(messages.day)}</Label>
                      <Input
                        aria-label="age-day"
                        className="w-100"
                        type="select"
                        placeholder="Day"
                        autoComplete="bday-day"
                        value={currentDay}
                        name="currentDay"
                        onChange={onChange}
                      >
                        <option value="">{formatMessage(messages.day)}</option>
                        {days.map(d =>
                          <option key={d} value={d}>{d}</option>,
                        )}
                      </Input>
                    </Col>
                    <Col>
                      <Label hidden>{formatMessage(messages.month)}</Label>
                      <Input
                        aria-label="age-month"
                        className="w-100"
                        type="select"
                        placeholder="Month"
                        autoComplete="bday-month"
                        value={currentMonth}
                        name="currentMonth"
                        onChange={onChange}
                      >
                        <option value="">{formatMessage(messages.month)}</option>
                        {months.map(m =>
                          <option key={m} value={m}>{m}</option>,
                        )}
                      </Input>
                    </Col>
                    <Col>
                      <Label hidden>formatMessage(messages.year)</Label>
                      <Input
                        aria-label="age-year"
                        className="w-100"
                        type="select"
                        placeholder="Year"
                        autoComplete="bday-year"
                        value={currentYear}
                        name="currentYear"
                        onChange={onChange}
                      >
                        <option value="">{formatMessage(messages.year)}</option>
                        {years.map(y =>
                          <option key={y} value={y}>{y}</option>,
                        )}
                      </Input>
                    </Col>
                  </Row>
                </FormGroup>
              </div>
              {ageSuccess &&
                <MessageBox
                  type="success"
                  title={formatMessage(messages.success_general_dob)}
                  message={formatMessage(messages.success_dob)}
                />
              }
              {ageFail &&
                <MessageBox
                  type="error"
                  title={formatMessage(messages.errorchangingdob)}
                  message={ageError}
                />
              }
              <div className="account-modal-form-buttons">
                <div className="form-button-container">
                  <Button color="primary" className="complete-button" disabled={false} onClick={save}><FormattedMessage id="dob-form.Update" defaultMessage="Update" /></Button>
                </div>
                <div className="form-button-container">
                  <Button className="complete-button" onClick={toggleEdit}><FormattedMessage id="dob-form.Cancel" defaultMessage="Close" /></Button>
                </div>
              </div>
            </div>
          }
        </ModalBody>
        <div aria-label="close" className="close-button-container">
          <button onClick={() => toggleEdit()}>
            <FontAwesomeIcon icon={faXmark} title="Close modal" />
          </button>
        </div>
      </Modal>
    </React.Fragment>
  );
};

Age.propsTypes = {
  dob: PropTypes.string,
};

Age.defaultProps = {
  dob: '',
};

const mapStateToProps = ({
  auth: { dob }, // eslint-disable-line camelcase
}) => ({
  dob,
});

export default connect(mapStateToProps)(injectIntl(Age));
